module.exports = __webpack_public_path__ + "static/media/red.17eaf9f9.svg";